import React, { useEffect, useState } from 'react';
import { ValueFormField, DropdownListViewModel, ListFieldItem } from '@sitecore-jss/sitecore-jss-forms';
import { FieldChangeCallback, Label, ListFieldProps } from '@sitecore-jss/sitecore-jss-react-forms';
import { FieldValidationErrors } from './FieldValidationErrors';
import { getFormFieldAriaProps, handleLoadValuesEvent } from '../Functions';

const handleOnChange = (field: ValueFormField, newValue: string, callback: FieldChangeCallback) => {
  let valid = true;
  const errorMessages = [];

  // custom client validation logic here
  if (field.model.required && !newValue) {
    valid = false;
    errorMessages.push(`${field.model.title} is required`);
  }

  callback(field.valueField.name, [newValue], valid, errorMessages);
};

export const DropdownListWithEvents: React.FunctionComponent<ListFieldProps<DropdownListViewModel>> = (props) => {
  const {
    field,
    field: {
      model: { items },
    },
    value,
    onChange,
    tracker,
    errors,
  } = props;

  const currentFieldName = field.model?.name || '';
  const showEmptyItem = field.model?.showEmptyItem || false;
  const [listOptions, setListOptions] = useState(items);

  const handleOnLoadValuesExternalEvent = (dropdownOptions: string[], triggerEvent = true) => {
    const listOfItems: ListFieldItem[] = [];

    if (dropdownOptions.length > 0) {
      dropdownOptions.forEach((option) => {
        return listOfItems.push({
          itemId: option,
          text: option,
          value: option,
          selected: false,
        });
      });

      if (!showEmptyItem) {
        onChange(field.valueField.name, [dropdownOptions[0]], true, []);
      }

      console.log('dropdownOptions: ', listOfItems, triggerEvent);
    }

    setListOptions(listOfItems);
  };

  // Handle external event to load dropdown options dynamically (e.g. Load counties based on zip code)
  useEffect(() => {
    const loadValuesHandler = (postMessageEvent: MessageEvent) => {
      handleLoadValuesEvent(postMessageEvent, currentFieldName, handleOnLoadValuesExternalEvent);
    };

    window.addEventListener('message', loadValuesHandler);
    return () => window.removeEventListener('message', loadValuesHandler);
  });

  return (
    <>
      <Label {...props} />
      <select
        className={field.model.cssClass}
        id={field.valueField.id}
        name={field.valueField.name}
        value={value[0]}
        onChange={(e) => handleOnChange(field, e.target.value, onChange)}
        onFocus={() => tracker.onFocusField(field, value)}
        onBlur={() => tracker.onBlurField(field, value, errors)}
        {...getFormFieldAriaProps(field, errors)}
      >
        {showEmptyItem ? <option label=" " /> : null}
        {listOptions.map((item) => (
          <option key={item.itemId} value={item.value}>
            {item.text}
          </option>
        ))}
      </select>

      <FieldValidationErrors {...props} />
    </>
  );
};

export default DropdownListWithEvents;
